import {Component, ConfigOptions} from 'panel';

import Persistence from 'common/report/persistence';
import {registerMPElement} from 'common/util/register-element';

import {WorkspaceDisclaimerAttrs, WorkspaceDisclaimerState} from './types';
import template from './index.jade';
import css from './index.styl?inline';

const PERSISTENCE_NAMESPACE = `workspaces`;
const LAST_DISMISSED = `last-dismiss`;

export default class WorkspaceDisclaimer extends Component<
  WorkspaceDisclaimerState,
  {},
  unknown,
  WorkspaceDisclaimerAttrs
> {
  private persistence: Persistence;
  static get attrsSchema() {
    return {
      ...super.attrsSchema,
      'workspace-id': `number`,
      'workspace-name': `string`,
    };
  }

  get config(): ConfigOptions<WorkspaceDisclaimerState, {}, WorkspaceDisclaimerAttrs> {
    return {
      css,
      template,
      useShadowDom: true,
      defaultState: {
        displayDisclaimer: false,
      },
      helpers: {
        handleDisclaimerBannerAction: () => {
          this.persistence.set(LAST_DISMISSED, Date.now());
          this.persistence.set(this.getDismissedKey(), Date.now());
          this.update({displayDisclaimer: false});
        },
      },
    };
  }

  constructor() {
    super();
    this.persistence = new Persistence(PERSISTENCE_NAMESPACE);
  }

  connectedCallback() {
    super.connectedCallback();
    const oneDay = 8.64e7;
    const lastDismiss = this.persistence.get(LAST_DISMISSED) ? parseInt(this.persistence.get(LAST_DISMISSED), 10) : 0;
    if (Date.now() - lastDismiss > oneDay && !this.persistence.get(this.getDismissedKey())) {
      this.update({displayDisclaimer: true});
    }
  }

  private getDismissedKey(): string {
    return `${this.attr(`workspace-id`)}:disclaimer-dismissed-at`;
  }
}

registerMPElement(`workspace-disclaimer-banner`, WorkspaceDisclaimer);
